import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { getStorage } from 'firebase/storage'
import { getFunctions } from 'firebase/functions'

// Firebase configuration
//
// HOW THIS WORKS:
// 1. In Vite builds (local dev / production): reads from .env via import.meta.env
// 2. In preview environments: falls back to the values below
//
// FOR BUYERS / DISTRIBUTION:
// - Copy .env.example to .env
// - Fill in YOUR Firebase project credentials
// - The .env values will override the fallbacks below
// - Get values from: Firebase Console → Project Settings → General → Your apps → Web app

// Safe env access — prevents crash if import.meta.env is unavailable
const env: Record<string, string> =
  typeof import.meta !== 'undefined' && import.meta.env
    ? (import.meta.env as unknown as Record<string, string>)
    : {}

const firebaseConfig = {
  apiKey:
    env.VITE_FIREBASE_API_KEY || 'AIzaSyA7je69QIWA-stQ37AOE6EnOlNwWOmTZYo',
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN || 'dgstack-eaec5.firebaseapp.com',
  projectId: env.VITE_FIREBASE_PROJECT_ID || 'dgstack-eaec5',
  storageBucket:
    env.VITE_FIREBASE_STORAGE_BUCKET || 'dgstack-eaec5.firebasestorage.app',
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID || '970117776005',
  appId:
    env.VITE_FIREBASE_APP_ID || '1:970117776005:web:e1aae2963fc4b97243dfec',
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)

// Initialize App Check with reCAPTCHA v3
// SETUP: Replace YOUR_SITE_KEY with your reCAPTCHA v3 site key from https://www.google.com/recaptcha/admin
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check'

// Enable App Check debug mode ONLY for local development
// In all other environments (production, preview, staging), App Check is fully enforced
const isLocalDev =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1')

if (isLocalDev) {
  // @ts-ignore — Firebase uses this global to enable debug tokens
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true
}

const recaptchaSiteKey =
  env.VITE_RECAPTCHA_V3_SITE_KEY || '6Le8lowsAAAAAK9YKbcQ1Q0MnAgpK8p9JfjNNmob'

try {
  if (recaptchaSiteKey && recaptchaSiteKey !== 'YOUR_SITE_KEY') {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(recaptchaSiteKey),
      isTokenAutoRefreshEnabled: true,
    })
  } else {
    console.warn(
      '[App Check] No valid reCAPTCHA site key found. App Check is disabled.',
    )
  }
} catch (appCheckError) {
  // App Check initialization failed — log so it's visible in production debugging
  console.warn('[App Check] Initialization failed:', appCheckError)
  console.warn(
    '[App Check] Ensure dgstack.io is registered in reCAPTCHA admin: https://www.google.com/recaptcha/admin',
  )
}

export const db = getFirestore(app)
export const auth = getAuth(app)
export const storage = getStorage(app)
export const functions = getFunctions(app)

export default app
